// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MediumOutlinedSvg from "@ant-design/icons-svg/es/asn/MediumOutlined";
import AntdIcon from '../components/AntdIcon';

var MediumOutlined = function MediumOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MediumOutlinedSvg
  }));
};

MediumOutlined.displayName = 'MediumOutlined';
export default React.forwardRef(MediumOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/MediumOutlined.js
// module id = 1461
// module chunks = 0